import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./styles.module.css";
import Home from "./pages/Home";
import Form from "./pages/Form";
import Landing from "./pages/Landing";
import Detail from "./pages/Detail";
import { Provider } from "react-redux";
import Store from "./redux/store/index";
import NoPage from "./components/notFound/NoPage";

export default function App() {
  return (
    <div className="App">
      <Provider store={Store}>
        <Router>
          <Switch>
            <Route path="/home/:id" component={Detail} />
            <Route exact path="/home" component={Home} />
            <Route path="/form" component={Form} />
            <Route exact path="/" component={Landing} />
            <Route path="*" component={NoPage} />
          </Switch>
        </Router>
      </Provider>
    </div>
  );
}
